import React from 'react';

type WordmarkSize = 'sm' | 'md' | 'lg';

interface WordmarkProps {
  size?: WordmarkSize;
  className?: string;
}

const SIZE_CLASSES: Record<WordmarkSize, string> = {
  sm: 'text-lg',
  md: 'text-2xl',
  lg: 'text-4xl',
};

/**
 * The Good Shout wordmark: display face, heavy weight, tight tracking,
 * finished with the red full stop from the brand sheet.
 *
 * Renders as a single inline element so text selectors ("Good Shout") keep
 * matching it.
 */
export const Wordmark: React.FC<WordmarkProps> = ({ size = 'md', className = '' }) => (
  <span
    className={`font-display font-extrabold tracking-tight text-brand-dark leading-none ${SIZE_CLASSES[size]} ${className}`}
  >
    Good Shout<span className="text-brand-red">.</span>
  </span>
);
